import { DATA_PERSISTENCE, DATA_APP_VISIBLE, DATA_POWERED_BY, DATA_ANIMATION, DATA_HIW, DATA_HEADER_BUTTONS_HOVER, DATA_FAB_BUTTON_STYLE, DATA_FAB_CLOSE_ICON, DATA_FIXED_MANDATORY_ATTRIBUTES, DATA_RIGHT_OFFSET, DATA_BOTTOM_OFFSET, DATA_EXPANDABLE_FAB, DATA_REACH_OUT_MODE, DATA_NEW_CONVERSATION_MODE, DATA_LLM_HEIGHT, DATA_CLEAR_SESSION_MSG, DATA_HIW_SET, DATA_USER_CAPTURE_SUPPRESS, DATA_FILL_AVAILABLE_SPACE } from "./ClientContext";
const boolExtractor = domValue => {
  if (domValue && domValue === "true") {
    return true;
  }
  return false;
};
export const getOptionConfigOptions = () => [{
  attributeKey: DATA_PERSISTENCE,
  classProp: "_persistenceEnabled",
  defaultValue: true
}, {
  attributeKey: DATA_APP_VISIBLE,
  classProp: "_appVisible",
  defaultValue: true,
  valueExtractor: domValue => {
    if (domValue === "always") {
      return "always";
    } else if (domValue === "false") {
      return false;
    } else {
      return true;
    }
  }
}, {
  attributeKey: DATA_POWERED_BY,
  classProp: "_poweredBy",
  defaultValue: true
}, {
  attributeKey: DATA_ANIMATION,
  classProp: "_animation",
  defaultValue: true
}, {
  attributeKey: DATA_HIW,
  classProp: "_hiwMode",
  defaultValue: "optional",
  valueExtractor: domValue => {
    if (domValue === "mandatory") {
      return "mandatory";
    } else if (domValue === "optional") {
      return "optional";
    } else if (domValue === "informational") {
      return "informational";
    } else {
      return "disabled";
    }
  }
}, {
  attributeKey: DATA_HEADER_BUTTONS_HOVER,
  classProp: "_headerButtonHoverEnabled",
  defaultValue: true
}, {
  attributeKey: DATA_FAB_BUTTON_STYLE,
  classProp: "_fabButtonStyle",
  defaultValue: "normal",
  valueExtractor: domValue => {
    if (domValue === "flat") {
      return "flat";
    } else if (domValue === "hidden") {
      return "hidden";
    } else {
      return "normal";
    }
  }
}, {
  attributeKey: DATA_FAB_CLOSE_ICON,
  classProp: "_fabCloseButtonStyle",
  defaultValue: "close",
  valueExtractor: domValue => {
    if (domValue === "chat") {
      return "chat";
    } else {
      return "close";
    }
  }
}, {
  attributeKey: DATA_FIXED_MANDATORY_ATTRIBUTES,
  classProp: "_fixedMandatoryAttributes",
  defaultValue: false
}, {
  attributeKey: DATA_BOTTOM_OFFSET,
  classProp: "_bottomOffset",
  defaultValue: 20,
  valueExtractor: domValue => {
    try {
      const offset = Number(domValue);
      return offset;
    } catch {
      return 20;
    }
  }
}, {
  attributeKey: DATA_RIGHT_OFFSET,
  classProp: "_rightOffset",
  defaultValue: "20px",
  valueExtractor: domValue => {
    if (!domValue.includes("px")) {
      return `${domValue}px`;
    }
    return domValue;
  }
}, {
  attributeKey: DATA_EXPANDABLE_FAB,
  classProp: "_expandableFab",
  defaultValue: false
}, {
  attributeKey: DATA_REACH_OUT_MODE,
  classProp: "_reachOutMode",
  defaultValue: "none",
  valueExtractor: domValue => {
    const VALID_VALUES = ["none", "static", "expert"];
    if (VALID_VALUES.includes(domValue)) {
      return domValue;
    }
    return "none";
  }
}, {
  attributeKey: DATA_NEW_CONVERSATION_MODE,
  classProp: "_newConversationMode",
  defaultValue: "standard",
  valueExtractor: domValue => {
    const VALID_VALUES = ["standard", "group-new-tab", "group-same-window"];
    if (VALID_VALUES.includes(domValue)) {
      return domValue;
    }
    return "standard";
  }
}, {
  attributeKey: DATA_LLM_HEIGHT,
  classProp: "_llmHeight",
  defaultValue: "525px",
  valueExtractor: domValue => {
    if (!domValue.includes("px")) {
      return `${domValue}px`;
    }
    return domValue;
  }
}, {
  attributeKey: DATA_CLEAR_SESSION_MSG,
  classProp: "_clearSessionMessage",
  defaultValue: false,
  valueExtractor: boolExtractor
}, {
  attributeKey: DATA_HIW_SET,
  classProp: "_hiwSet",
  defaultValue: null,
  valueExtractor: domValue => {
    if (domValue && !Number.isNaN(domValue)) {
      return Number(domValue);
    }
    return null;
  }
}, {
  attributeKey: DATA_USER_CAPTURE_SUPPRESS,
  classProp: "_userCaptureSuppress",
  defaultValue: "",
  valueExtractor: domValue => {
    const VALID_VALUES = ["name", "email", "all"];
    if (VALID_VALUES.includes(domValue)) {
      return domValue;
    }
    return "";
  }
}, {
  attributeKey: DATA_FILL_AVAILABLE_SPACE,
  classProp: "_fillAvailableSpace",
  defaultValue: false,
  valueExtractor: boolExtractor
}];